import { learningPath } from './learningPath'
import { profiles } from './profiles'
import { webinars } from './webinars'
import { questionBank } from './questionBank'

export const slices = {
  learningPath,
  questionBank,
  profiles,
  webinars,
}
